import { normalizeHolidays } from './normalize-holidays';

/**
 * Lookup table for holidays.
 * @type object
 */
export const _holidaysForStaffingCalendar = normalizeHolidays();
